import React from 'react';

class ShelfLifeBadge extends React.Component {
  getColor(percent, status) {
    if (status === 'discarded') return '#6c757d';   // gray
    if (status === 'quarantine') return '#6f42c1';  // purple
    if (percent <= 20) return '#c9140e';             // red
    if (percent <= 50) return '#e0a800';             // amber
    return '#1a8a3a';                                 // green
  }

  getLabel(days, status) {
    if (status === 'discarded') return 'Discarded';
    if (status === 'quarantine') return 'Quarantine';
    if (days === 1) return '1 day left';
    return `${days} days left`;
  }

  render() {
    const { days, percent, status } = this.props;
    const color = this.getColor(percent, status);
    const label = this.getLabel(days, status);
    const barWidth = status === 'discarded' || status === 'quarantine' ? 100 : percent;

    return (
      <div style={{ minWidth: 90 }}>
        <div className="progress" style={{ height: 6 }}>
          <div
            className="progress-bar"
            style={{ width: `${barWidth}%`, backgroundColor: color }}
          />
        </div>
        <small style={{ color, fontWeight: 600 }}>{label}</small>
      </div>
    );
  }
}

export default ShelfLifeBadge;
